<template>
  <div class="block relative">
        <button v-on:click="isSure = !isSure" class="btn btn-red mt-3 commitbutton text-xs w-full block">Restart All Activities</button>
        <transition name="fade">
          <div v-if="!isSure" class="bg-red-600 text-white w-full p-3 absolute bottom-0 left-0 text-sm z-50" v-click-outside="onClickOutside">
              <strong>Are You Sure?</strong><br> <span class="text-xs">This will remove your answers and start you back at the beginning.</span><br>
              <button id="toggleSharing" @click="putItem" type="submit" class="btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i>Yes, Restart</button>
          </div>
        </transition>
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {

        props: {
            route:'',
            wizardname: '',
        },

        directives: {
          clickOutside: vClickOutside.directive
        },

        data() {
          return {
            isSure: true,
          }
        },

        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },
          putItem: function (event) {
              $( ".commitbutton").addClass( "loading" );
              axios.delete(this.route)
              .then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.href = "/explore";
                })
          }

        },
      }
</script>
